import { PARTNER_LOGOS } from '../../../../content/staticAssets';

export default function PartnerBadges() {
  return (
    <div
      className="w-full border-t border-b border-blue-100 py-6"
      style={{ background: 'rgba(240, 250, 255, 0.6)' }}
    >
      <div className="container-x flex justify-center">
        <div className="flex max-w-full flex-wrap items-center overflow-hidden rounded-xl border border-gray-200 bg-white">
          <div className="flex shrink-0 items-center px-4 py-3">
            <img src={PARTNER_LOGOS.snowflake} alt="Snowflake" className="h-6 w-auto max-w-full" />
          </div>
          <span className="border-l border-gray-200 px-4 py-3 text-xs font-medium text-ink-600 whitespace-normal sm:whitespace-nowrap">
            Partner Network Member
          </span>
        </div>
      </div>
    </div>
  );
}
